import { MessageSystem } from '@halo/ui-chat-react';
import { MsgItem } from '../../msg-parts';
import type { MsgGroupUpdateJoinContentProps } from './msg-group-update-join-content';
import { MsgGroupUpdateJoinContent } from './msg-group-update-join-content';

export interface MsgGroupUpdateJoinProps extends MsgGroupUpdateJoinContentProps {}

export const MsgGroupUpdateJoin = memo(function MsgGroupUpdateJoin({
  message,
}: MsgGroupUpdateJoinProps) {
  return (
    <MsgItem message={message}>
      <MessageSystem>
        <MsgGroupUpdateJoinContent message={message} />
      </MessageSystem>
    </MsgItem>
  );
});
